import { MazeShape } from "./maze-types";

export const SIZE_THUMB = 7;
export const LINE_WIDTH_THUMB = 1;
export const HALF_SIZE_THUMB = 3;

export const COLOR_PATH = "rgb(76,131,174)";
export const COLOR_THUMB_LINE = "rgb(6,14,20)";
export const LINE_WIDTH_PATH = 3;

export const MAZE_SHAPES: MazeShape[] = [
    {
        name: "square",
        width: 64,
        height: 64,
        path: "M 0 0 H 64 V 64 H -64 Z"
    },
    {
        name: "circle",
        width: 640,
        height: 640,
        path: "M 629 320 L 623 380 L 605 438 L 577 491 L 538 538 L 491 577 L 438 605 L 380 623 L 320 629 L 260 623 L 202 605 L 149 577 L 102 538 L 63 491 L 35 438 L 17 380 L 11 320 L 17 260 L 35 202 L 63 149 L 102 102 L 149 63 L 202 35 L 260 17 L 320 11 L 380 17 L 438 35 L 491 63 L 538 102 L 577 149 L 605 202 L 623 260 Z"
    },
    { name: "diamond", width: 64, height: 64, path: "M 0 32 L 32 0 L 64 32 L 32 64 Z" },
    { name: "l", width: 64, height: 64, path: "M 0 0  L 32 0 L 32 32 L 64 32 V 64 H 0 Z" },
    {
        name: "star",
        width: 64,
        height: 64,
        path: "M 32 0 L 22.626953 9.3730469 L 9.3730469 9.3730469 L 9.3730469 22.626953 L 0 32 L 9.3730469 41.373047 L 9.3730469 54.626953 L 22.626953 54.626953 L 32 64 L 41.373047 54.626953 L 54.626953 54.626953 L 54.626953 41.373047 L 64 32 L 54.626953 22.626953 L 54.626953 9.3730469 L 41.373047 9.3730469 L 32 0 z "
    },
    {
        name: "donut",
        width: 640,
        height: 640,
        path: "M 320 0.52 L 258 6.72 L 198 25.3 L 143 54.3 L 94.6 94.6 L 54.3 143 L 25.3 198 L 6.72 258 L 0.52 320 L 6.72 382 L 25.3 442 L 54.3 497 L 94.6 545 L 143 586 L 198 615 L 258 633 L 320 639 L 382 633 L 442 615 L 497 586 L 545 545 L 586 497 L 615 442 L 633 382 L 639 320 L 633 258 L 615 198 L 586 143 L 545 94.6 L 497 54.3 L 442 25.3 L 382 6.72 L 320 0.52 z M 320 160 L 351 163 L 381 173 L 408 187 L 433 207 L 453 232 L 467 259 L 477 289 L 480 320 L 477 351 L 467 381 L 453 408 L 433 433 L 408 453 L 381 467 L 351 477 L 320 480 L 289 477 L 259 467 L 232 453 L 207 433 L 187 408 L 173 381 L 163 351 L 160 320 L 163 289 L 173 259 L 187 232 L 207 207 L 232 187 L 259 173 L 289 163 L 320 160 z "
    },
    { name: "box", width: 64, height: 64, path: "M 64,16 V 0 H 0 V 64 H 64 V 16 Z M 48,16 v 32 h -32 v -32 z" },
    { name: "hourglass", width: 64, height: 64, path: "M 64 0 H 0 L 28 32 L 0 64 H 64 L 38 32 Z" },
    { name: "twoBoxes", width: 64, height: 64, path: "M 36,0 L 0,0 V 36 H 28 V 64 L 64,64 L 64,28 H 36 Z" },
    {
        name: "fourBoxes",
        width: 64,
        height: 64,
        path: "M 0,0 h 28 v 18 h 8 V 0 L 64,0.18 V 36 H 6 v 6 H 64 V 64 H 36 V 48 H 28 V 64 H 0 V 30 H 58 V 24 H 0 Z"
    }
];
